import { render, staticRenderFns } from "./SageErroresTemplateComponent.vue?vue&type=template&id=26f2a5d2&scoped=true&lang=pug"
import script from "./SageErroresTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./SageErroresTemplateComponent.vue?vue&type=script&lang=ts"
import style0 from "./SageErroresTemplateComponent.vue?vue&type=style&index=0&id=26f2a5d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f2a5d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f2a5d2')) {
      api.createRecord('26f2a5d2', component.options)
    } else {
      api.reload('26f2a5d2', component.options)
    }
    module.hot.accept("./SageErroresTemplateComponent.vue?vue&type=template&id=26f2a5d2&scoped=true&lang=pug", function () {
      api.rerender('26f2a5d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/SageErroresTemplateComponent.vue"
export default component.exports